import { render } from "./ServerErrorToast.vue?vue&type=template&id=51137522&scoped=true"
import script from "./ServerErrorToast.vue?vue&type=script&lang=js"
export * from "./ServerErrorToast.vue?vue&type=script&lang=js"

import "./ServerErrorToast.vue?vue&type=style&index=0&id=51137522&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51137522"]])

export default __exports__